<template>
  <b-list-group
    style="margin-top: 30px"
  >
    <b-list-group-item class="process-head">
      <span> <feather-icon icon="ActivityIcon" /> Task Progress</span>
    </b-list-group-item>
    <b-list-group-item
      v-for="(item, index) in allProgress"
      :key="item.id"
      :class="(item.isHeader)? (((item.isStart === 1 || item.isSolo === 1 ) || (item.hasStart && item.firstElement >= item.start_id)) && !item.taskSolo)? 'block-header selected': 'block-header' : '' "
    >
      <div
        v-if="item.isHeader"
      >
        <span>{{ item.name }}</span>
        <div style="text-align: center;margin-top:10px">
          <b-button
            :variant="(item.isSolo === 1 && !item.taskSolo)? 'success' :'outline-secondary'"
            size="sm"
            style="margin-left:15px; font-size:10px"
            :disabled="disabled"
            @click="setSolo(item.firstElement)"
          >
            RUN BLOCK
          </b-button>

          <b-button
            :variant="(item.isStart === 1 && !item.taskSolo)? 'success' :'outline-secondary'"
            size="sm"
            style="margin-left:15px; font-size:10px"
            :disabled="disabled"
            @click="setStart(item.firstElement)"
          >
            START FROM THIS BLOCK
          </b-button>
        </div>
      </div>
      <div
        v-if="!item.isHeader"
      >
        <div
          class="d-flex justify-content-between align-items-center"
        >
          <span> <b-badge
            variant="secondary"
            style="margin-right: 10px"
          >
            {{ item.id }}
          </b-badge>{{ item.name }}</span>
          <b-badge
            v-if="!((item.hasStart && item.data.queue_id < item.start_id) || (item.hasSolo && item.data.step !== item.soloBlock) ) && (item.data.status === 0 && item.data.ind !== -1)"
            class="badge-glow"
            variant="light-warning"
            @click="setSoloTask(item, index)"
          >
            pending
          </b-badge>
          <b-badge
            v-if="!((item.hasStart && item.data.queue_id < item.start_id) || (item.hasSolo && item.data.step !== item.soloBlock)) && (item.data.status === 2 && item.data.ind !== -1)"
            class="badge-glow"
            variant="light-success"
            @click="setSoloTask(item, index)"
          >
            done
          </b-badge>
          <b-badge
            v-if=" ((item.hasStart && item.data.queue_id < item.start_id) || (item.hasSolo && item.data.step !== item.soloBlock)) || item.data.ind === -1"
            class="badge-glow"
            variant="light-danger"
            @click="setSoloTask(item, index)"
          >
            disabled
          </b-badge>
        </div>
        <div
          v-if="item.data.status === 1"
          class="task-progress"
        >
          <div class="d-flex space-around align-items-center">
            <div style="width:70px; text-align:center; margin-top: -25px;">
              <radial-progress-bar
                :diameter="70"
                :completed-steps="parseFloat(item.data.progress.percent)"
                :total-steps="100"
                :stroke-width="6"
                :inner-stroke-width="6"
                inner-stroke-color="#02838024"
                start-color="#028380"
                stop-color="#028380"
              />
              <div class="progress-percent">
                {{ item.data.progress.percent }}%
              </div>
            </div>
            <div style="margin-left: 40px">
              <div>
                <div><feather-icon
                  icon="CpuIcon"
                  style="margin-right:10px"
                /><strong>CPU:</strong> {{ Math.round(JSON.parse(item.data.task_status.data).cpu * 100) / 100 }} %</div>
              </div>
              <div><div><feather-icon
                icon="ActivityIcon"
                style="margin-right:10px"
              /> <strong>RAM:</strong> {{ Math.round(JSON.parse(item.data.task_status.data)["RAM (%)"] * 100) / 100 }} %. - {{ Math.round(JSON.parse(item.data.task_status.data)["RAM (GB)"] * 100) / 100 }} GB.</div></div>

              <div>
                <div><feather-icon
                  icon="ClockIcon"
                  style="margin-right:10px"
                /><strong>RUNNING TIME:</strong> {{ timeFormat(Math.round(JSON.parse(item.data.task_status.data)["Running Time (seconds)"])) }}</div>
              </div>
            </div>
          </div></div>
      </div>
    </b-list-group-item>
  </b-list-group>
</template>
<script>
/* eslint-disable no-plusplus */
import {
  BListGroup, BListGroupItem, BBadge, BButton,
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import RadialProgressBar from 'vue-radial-progress'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BBadge,
    RadialProgressBar,
    BButton,
  },
  props: {
    progress: {
      required: true,
      type: [String, Object, Boolean, Number, Array],
    },
    computing: {
      required: true,
      type: Number,
    },
    disabled: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      blocks: [],
      clicked: -1,
    }
  },
  computed: {
    allProgress() {
      const final = []
      const final2 = []
      let hasSolo = false
      let hasStart = false
      let startId = 0
      let soloBlock = 0
      for (let index = 0; index < this.blocks.length; index++) {
        const element = this.blocks[index]
        let exists = false
        element.isHeader = true
        element.firstElement = undefined
        for (let index2 = 0; index2 < element.blocks.length; index2++) {
          const block = element.blocks[index2]
          block.isHeader = false
          const find = this.progress.find(el => el.block === block.id)
          const filter = this.progress.filter(el => el.ind !== -1)
          element.taskSolo = (filter.length === 1)
          if (find !== undefined) {
            block.data = find
            block.data.step = element.step
            if (element.firstElement === undefined) {
              element.firstElement = find.queue_id
              element.isSolo = find.solo
              element.isStart = find.start
            }
            if (find.solo === 1) {
              hasSolo = true
              soloBlock = element.step
            }
            if (find.start === 1) {
              hasStart = true
              startId = find.queue_id
            }
            if (!exists) {
              final.push(element)
            }
            final.push(block)
            exists = true
          }
        }
      }
      for (let index = 0; index < final.length; index++) {
        const element = final[index]
        element.hasStart = hasStart
        element.hasSolo = hasSolo
        element.start_id = startId
        element.soloBlock = soloBlock
        if (this.clicked !== -1 && element.data !== undefined) {
          element.data.solo = (this.clicked === index) ? 1 : 0
          element.data.start = (this.clicked === index) ? 1 : 0
          element.data.status = (this.clicked === index) ? 0 : 0
          element.data.ind = (this.clicked === index) ? 0 : -1
        }
        final2.push(element)
      }
      return final2
    },
  },
  watch: {
    computing() {
      console.log('CHANGE computing')
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      axios.get(`${url}:${port}/blocks`, { headers }).then(result => {
        this.blocks = result.data.blocks
      })
    },
    setSolo(id) {
      axios.put(`${url}:${port}/block-solo/${id}`, {}, { headers }).then(result => {
        this.clicked = -1
        console.log(result)
      })
    },
    setSoloTask(item, index) {
      this.clicked = index
      const id = item.data.queue_id
      axios.put(`${url}:${port}/task-solo/${id}`, {}, { headers })
    },
    setStart(id) {
      axios.put(`${url}:${port}/block-start/${id}`, {}, { headers }).then(result => {
        this.clicked = -1
        console.log(result)
      })
    },
    timeFormat(t) {
      const h = Math.floor(t / 3600)
      const m = Math.floor((t % 3600) / 60)
      const s = Math.floor(t % 60)

      const hDisplay = h > 0 ? (h < 10 ? '0' : '') + h : '00'
      const mDisplay = m > 0 ? (m < 10 ? '0' : '') + m : '00'
      const sDisplay = s > 0 ? (s < 10 ? '0' : '') + s : '00'
      return `${hDisplay}:${mDisplay}:${sDisplay}`
    },
  },
}
</script>
<style>
.block-header{
  background:#00000020;
  color: #000;
  font-weight: 400;
}
.block-header.selected{
background: #09dd5520 !important;
}
.list-group .list-group-item.block-header:hover{
  background:#00000020;
  color: #000;
  font-weight: 400;
}
.task-progress{
  height: 100px;
  margin-top: 20px;
  margin-bottom: -25px;
}
.progress-percent{
  margin-top: -45px;
}
.task-data div{
  margin-right: 20px;
}
</style>
